import styled from '@emotion/styled';
import { Region } from '@kaizenplatform/hugot-entity';
import { Paper } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { ChangeEvent, createElement, ReactNode, useEffect, useState } from 'react';

import AmazonIcon from '../primitive/AmazonIcon';
import FacebookIcon from '../primitive/FacebookIcon';
import GoogleAdsIcon from '../primitive/GoogleAdsIcon';
import TiktokIcon from '../primitive/TiktokIcon';
import YahooIcon from '../primitive/YahooIcon';
import YouTubeIcon from '../primitive/YouTubeIcon';
import AmazonAdAccountConfiguration from './AmazonAdAccountConfiguration';
import FacebookAdAccountConfiguration from './FacebookAdAccountConfiguration';
import GoogleAdAccountConfiguration from './GoogleAdAccountConfiguration';
import TiktokAdAccountConfiguration from './TiktokAdAccountConfiguration';
import YahooAdAccountConfiguration from './YahooAdAccountConfiguration';
import YoutubeChannelConfiguration from './YoutubeChannelConfiguration';

interface TabPanelProps {
  children?: ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

function ExternalAccountsTabs({ region }: { region: Region }) {
  const classes = useStyles();
  const [value, setValue] = useState(0);

  const valueOfTiktok = region == 'jp' ? 5 : 4;

  useEffect(() => {
    if (location.href.match(/\?amazonAdAuthCode=/) && !location.href.match(/#tried/)) {
      setValue(3);
    } else if (location.href.match(/\?yahooAdAuthCode=/) && !location.href.match(/#tried/)) {
      setValue(4);
    } else if (location.href.match(/tiktokAdAuthCode=/) && !location.href.match(/#tried/)) {
      setValue(region == 'jp' ? 5 : 4);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [region]);

  const handleChange = (_: ChangeEvent<any>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Root className={classes.root}>
      <AppBar position="static" color="default">
        <Tabs value={value} onChange={handleChange} aria-label="external accounts">
          <Tab
            icon={<FacebookIcon size={25} color="#3B5998" />}
            label="Facebook"
            style={{ textTransform: 'none' }}
            {...a11yProps(0)}
          />
          <Tab
            icon={<GoogleAdsIcon size={25} />}
            label="Google Ads"
            style={{ textTransform: 'none' }}
            {...a11yProps(1)}
          />
          <Tab icon={<YouTubeIcon size={25} />} label="YouTube" style={{ textTransform: 'none' }} {...a11yProps(2)} />
          <Tab icon={<AmazonIcon size={25} />} label="Amazon" style={{ textTransform: 'none' }} {...a11yProps(3)} />
          {region === 'jp' && (
            <Tab icon={<YahooIcon size={25} />} label="Yahoo" style={{ textTransform: 'none' }} {...a11yProps(4)} />
          )}
          <Tab
            icon={<TiktokIcon size={25} />}
            label="TikTok"
            style={{ textTransform: 'none' }}
            {...a11yProps(valueOfTiktok)}
          />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <FacebookAdAccountConfiguration />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <GoogleAdAccountConfiguration />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <YoutubeChannelConfiguration />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <AmazonAdAccountConfiguration />
      </TabPanel>
      {region === 'jp' && (
        <TabPanel value={value} index={4}>
          <YahooAdAccountConfiguration />
        </TabPanel>
      )}
      <TabPanel value={value} index={valueOfTiktok}>
        <TiktokAdAccountConfiguration />
      </TabPanel>
    </Root>
  );
}

const Root = styled(Paper)();

export default ExternalAccountsTabs;
